import {reaction} from 'mobx';
import {observer} from 'mobx-react';
import React from 'react';
import {Disposers} from '../../../../../lib/helpers';
import {EditContentStore} from '../../../x7/content-parts/EditContentStore';
import {SelectQuestionModel} from '../models';
import {SelectQuestionEditStore} from './SelectQuestionEditStore';
import {selectQuestionEditStoreRenderer} from './selectQuestionEditStoreRenderer';

@observer
export class SelectQuestionEditComponent extends React.Component<{ store: EditContentStore }> {
  readonly store: SelectQuestionEditStore;
  readonly disposers = new Disposers();

  constructor(props: Readonly<{ store: EditContentStore; }>) {
    super(props);
    this.store = new SelectQuestionEditStore();

    const value = props.store.content.Contents;
    const model = JSON.parse(value) as SelectQuestionModel;
    this.store.setModel(model);

    this.setup();
  }

  setup() {
    this.disposers.add(
      reaction(
        () => this.store.valid,
        () => this.props.store.setValid(this.store.valid),
        {fireImmediately: true}),
      reaction(
        () => this.store.x9Content,
        () => this.props.store.setContents(this.store.x9Content),
        {fireImmediately: true}
      ));
  }

  render() {
    return Array.from(selectQuestionEditStoreRenderer(this.store));
  }

  componentWillUnmount() {
    this.disposers.dispose();
  }
}
